import flatpickr from 'flatpickr';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import 'flatpickr/dist/flatpickr.min.css';
import '../flatpickr-securepay.css';

document.addEventListener('DOMContentLoaded', () => {
    const dropZone = document.getElementById('drop_zone');
    const fileInput = document.getElementById('plik_upload');

    if (!dropZone || !fileInput) return;

    const label = dropZone.querySelector('label');
    const imgIcon = dropZone.querySelector('img'); // Pobieramy główną ikonę chmurki
    const textMain = dropZone.querySelector('p.mb-2');
    const textSub = dropZone.querySelector('p.text-\\[14px\\]'); 
    
    // Zapamiętujemy oryginalne elementy, żeby móc do nich wracać po usunięciu ostatniego pliku
    const originalTextMain = textMain.innerText;
    const originalTextSub = textSub.innerText;

    // Zbiór aktualnie wybranych plików — kumulowany między kolejnymi wyborami/upuszczeniami,
    // bo natywny <input type="file"> nadpisuje całą listę przy każdej interakcji.
    let selectedFiles = [];

    // Gdy dodanie kolejnych plików przekroczy łączny limit 25MB, tu trzymamy PEŁNĄ listę
    // (stare + nowe), żeby użytkownik widział wszystko i mógł usunąć dowolne pozycje,
    // aż zmieści się w limicie. Do czasu rozwiązania input pozostaje przy poprzednim,
    // poprawnym stanie (selectedFiles) — nic ponad limit nie trafia do wysyłki.
    let pendingOverLimitFiles = null;

    // Ustawienia
    const maxSize = 25 * 1024 * 1024; // 25MB
    const allowedExtensions = /(\.pdf|\.jpg|\.jpeg|\.png)$/i;
    const loadingTime = 800; // Czas animacji ładowania w milisekundach (0.8 sekundy)

    // --- Blokada domyślnych akcji przeglądarki ---
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        dropZone.addEventListener(eventName, preventDefaults, false);
        document.body.addEventListener(eventName, preventDefaults, false);
    });

    function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    // --- Podświetlanie przy najechaniu (Hover) ---
    ['dragenter', 'dragover'].forEach(eventName => {
        dropZone.addEventListener(eventName, highlight, false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
        dropZone.addEventListener(eventName, unhighlight, false);
    });

    function highlight(e) {
        label.classList.add('border-securepay-blue', 'bg-blue-50');
        label.classList.remove('border-[#DAB2FF]', 'bg-[#FCFAFE]');
    }

    function unhighlight(e) {
        label.classList.remove('border-securepay-blue', 'bg-blue-50');
        label.classList.add('border-[#DAB2FF]', 'bg-[#FCFAFE]');
    }

    // --- Obsługa upuszczenia i wyboru ---
    dropZone.addEventListener('drop', handleDrop, false);

    function handleDrop(e) {
        const files = e.dataTransfer.files;
        if (files.length) {
            addFiles(files);
        }
    }

    fileInput.addEventListener('change', function() {
        if (this.files && this.files.length) {
            addFiles(this.files);
        } else {
            syncFileInput(); // np. anulowano wybór w oknie systemowym — przywracamy poprzedni stan
        }
    });

    // Dopisuje nowo wybrane/upuszczone pliki do już zaakceptowanych (lub do listy
    // oczekującej na przycięcie po przekroczeniu limitu) zamiast je zastępować
    function addFiles(newFiles) {
        const base = pendingOverLimitFiles || selectedFiles;
        const incoming = Array.from(newFiles).filter(
            candidate => !base.some(f => filesEqual(f, candidate))
        );

        if (!incoming.length) {
            syncFileInput();
            return;
        }

        validateWithLoading(incoming);
    }

    function filesEqual(a, b) {
        return a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;
    }

    // --- Usuwanie pojedynczego pliku z listy / zamykanie komunikatu błędu przyciskiem "OK" ---
    dropZone.addEventListener('click', function(e) {
        const removeBtn = e.target.closest('[data-remove-index]');
        const dismissBtn = e.target.closest('[data-dismiss-error]');
        if (!removeBtn && !dismissBtn) return;

        // Blokujemy domyślne zachowanie <label>, żeby klik w przycisk nie otwierał okna wyboru pliku
        e.preventDefault();
        e.stopPropagation();

        if (removeBtn) {
            removeFile(parseInt(removeBtn.getAttribute('data-remove-index'), 10));
        } else {
            // Błąd formatu nie zmienia selectedFiles — po prostu wracamy do poprzedniego, poprawnego widoku
            selectedFiles.length ? showSuccess(selectedFiles) : resetUI();
        }
    });

    function removeFile(index) {
        // Usuwanie z listy "za dużo, przytnij" — sprawdzamy, czy po usunięciu mieścimy się w limicie
        if (pendingOverLimitFiles) {
            pendingOverLimitFiles.splice(index, 1);
            const totalSize = pendingOverLimitFiles.reduce((sum, f) => sum + f.size, 0);

            if (totalSize <= maxSize) {
                selectedFiles = pendingOverLimitFiles;
                pendingOverLimitFiles = null;
                syncFileInput();
                selectedFiles.length ? showSuccess(selectedFiles) : resetUI();
            } else {
                showSizeLimitError();
            }
            return;
        }

        selectedFiles.splice(index, 1);
        syncFileInput();

        if (selectedFiles.length) {
            showSuccess(selectedFiles);
        } else {
            resetUI();
        }
    }

    function resetUI() {
        imgIcon.classList.remove('hidden');
        textSub.classList.remove('hidden');

        label.classList.remove('border-red-500', 'bg-red-50', 'border-green-500', 'bg-green-50', 'border-securepay-blue', 'bg-blue-50');
        label.classList.add('border-[#DAB2FF]', 'bg-[#FCFAFE]');

        textMain.innerText = originalTextMain;
        textSub.innerText = originalTextSub;
        textSub.classList.remove('text-red-500', 'font-medium');
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    // Odtwarza FileList na inpucie na podstawie selectedFiles — konieczne, bo
    // natywny picker/drop nadpisuje input.files przy każdej kolejnej interakcji.
    function syncFileInput() {
        const dt = new DataTransfer();
        selectedFiles.forEach(file => dt.items.add(file));
        fileInput.files = dt.files;
    }

    // --- Główna logika z animacją (UX) ---
    function validateWithLoading(incomingFiles) {
        // 1. Zaczynamy od pokazania animacji ładowania
        showLoading();

        // 2. Symulujemy "myślenie" systemu
        setTimeout(() => {

            // Krok A: Sprawdzamy format nowo dodawanych plików (zanim w ogóle rozważymy je do listy)
            for (let i = 0; i < incomingFiles.length; i++) {
                if (!allowedExtensions.exec(incomingFiles[i].name)) {
                    showError('Niedozwolony format. Wybierz pliki PDF, JPG lub PNG.');
                    syncFileInput();
                    return;
                }
            }

            // Krok B: Sprawdzamy łączny rozmiar (już zaakceptowane/oczekujące + nowe)
            // (limit CF7 "limit:25mb" jest sumą rozmiarów wszystkich plików, nie limitem na plik)
            const combined = (pendingOverLimitFiles || selectedFiles).concat(incomingFiles);
            const totalSize = combined.reduce((sum, f) => sum + f.size, 0);

            if (totalSize > maxSize) {
                // Pokazujemy WSZYSTKIE pliki (stare + nowe) — dopiero wtedy usuwanie ma sens.
                // Input celowo zostaje na razie przy poprzednim, poprawnym stanie.
                pendingOverLimitFiles = combined;
                showSizeLimitError();
                return;
            }

            // Krok C: Walidacja przeszła — dopisujemy nowe pliki do listy i pokazujemy sukces
            pendingOverLimitFiles = null;
            selectedFiles = combined;
            syncFileInput();
            showSuccess(selectedFiles);

        }, loadingTime); // Uruchamiamy walidację po czasie loadingTime
    }

    // --- Funkcje modyfikujące UI ---

    function showLoading() {
        imgIcon.classList.add('hidden'); // Ukrywamy statyczną ikonę
        textSub.classList.add('hidden'); // Ukrywamy dolny tekst

        label.classList.add('border-securepay-blue', 'bg-blue-50');
        label.classList.remove('border-[#DAB2FF]', 'bg-[#FCFAFE]', 'border-red-500', 'bg-red-50', 'border-green-500', 'bg-green-50');

        // Wstawiamy kręcący się spinner SVG z Tailwinda
        textMain.innerHTML = `
            <div class="flex flex-col items-center justify-center space-y-4">
                <svg class="animate-spin h-10 w-10 text-securepay-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span class="text-securepay-blue font-bold text-[19px]">Przetwarzanie plików...</span>
            </div>
        `;
    }

    // Lista załączonych plików z przyciskiem "Usuń" — używana zarówno w stanie sukcesu,
    // jak i w stanie błędu (żeby zawsze dało się coś usunąć). Na mobile nazwa pliku
    // i przycisk są jeden nad drugim (pełna szerokość, wygodnie w dotyku), a od sm:
    // w górę stoją obok siebie w jednej linii.
    function renderFileListHtml(files) {
        return Array.from(files).map((file, index) => {
            const name = escapeHtml(file.name);
            return `<span class="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-3">
                <span class="break-words">${name}</span>
                <button type="button" class="inline-flex items-center justify-center px-4 py-2 text-[13px] font-semibold text-red-600 bg-red-50 hover:bg-red-100 active:bg-red-200 border border-red-200 rounded-full transition" data-remove-index="${index}" aria-label="Usuń plik ${name}">
                    Usuń
                </button>
            </span>`;
        }).join('');
    }

    function showSuccess(files) {
        const totalSizeMB = (Array.from(files).reduce((sum, f) => sum + f.size, 0) / (1024 * 1024)).toFixed(2);

        textSub.classList.remove('hidden'); // Pokazujemy z powrotem tekst pod spodem

        label.classList.add('border-green-500', 'bg-green-50');
        label.classList.remove('border-securepay-blue', 'bg-blue-50', 'border-red-500', 'bg-red-50');

        textMain.innerHTML = `<span class="text-[24px] mb-2 block">✅</span><span class="text-green-700 font-bold text-[19px] block mb-1">Załączono:</span><span class="text-green-700 font-medium text-[16px] leading-[22px] block space-y-3">${renderFileListHtml(files)}</span>`;
        textSub.innerHTML = `Łączny rozmiar: ${totalSizeMB} MB. Kliknij, aby dodać kolejne pliki.`;
        textSub.classList.remove('text-red-500', 'font-medium');
    }

    // Stan "za dużo plików łącznie" — pokazuje WSZYSTKIE pliki (stare + nowe),
    // żeby usuwanie miało sens (w przeciwieństwie do listy samych już-poprawnych plików).
    function showSizeLimitError() {
        const totalSizeMB = (pendingOverLimitFiles.reduce((sum, f) => sum + f.size, 0) / (1024 * 1024)).toFixed(2);

        textSub.classList.remove('hidden');

        label.classList.add('border-red-500', 'bg-red-50');
        label.classList.remove('border-securepay-blue', 'bg-blue-50', 'border-green-500', 'bg-green-50');

        textMain.innerHTML = `<span class="text-[24px] mb-2 block">❌</span><span class="text-red-600 font-bold text-[19px] block mb-1">Załączone pliki są za duże.</span><span class="text-red-700 font-medium text-[16px] leading-[22px] block space-y-3">${renderFileListHtml(pendingOverLimitFiles)}</span>`;
        textSub.innerHTML = `Łączny rozmiar: ${totalSizeMB} MB. Maksymalny łączny rozmiar to 25 MB. Usuń pliki, aby zmieścić się w limicie.`;
        textSub.classList.add('text-red-500', 'font-medium');
    }

    function showError(msg) {
        textSub.classList.remove('hidden');

        label.classList.add('border-red-500', 'bg-red-50');
        label.classList.remove('border-securepay-blue', 'bg-blue-50', 'border-green-500', 'bg-green-50');

        // Jeśli mamy już jakieś poprawnie zaakceptowane pliki, pokazujemy je nadal (z możliwością
        // usunięcia) oraz przycisk "OK" — błąd formatu nie zmienia tej listy, więc najczęściej
        // wystarczy po prostu wrócić do poprzedniego widoku bez usuwania czegokolwiek.
        if (selectedFiles.length) {
            textMain.innerHTML = `<span class="text-[24px] mb-2 block">❌</span><span class="text-red-600 font-bold text-[19px] block mb-1">Wystąpił problem</span><span class="text-red-700 font-medium text-[16px] leading-[22px] block space-y-3">${renderFileListHtml(selectedFiles)}</span>`;
            textSub.innerHTML = `${msg}<span class="block mt-3"><button type="button" class="inline-flex items-center justify-center px-6 py-2 text-[14px] font-semibold text-white bg-gray-500 hover:bg-gray-600 rounded-full transition" data-dismiss-error>OK</button></span>`;
        } else {
            textMain.innerHTML = `<span class="text-[24px] mb-2 block">❌</span><span class="text-red-600 font-bold text-[19px]">Wystąpił problem</span>`;
            textSub.innerHTML = msg;
        }

        textSub.classList.add('text-red-500', 'font-medium');
    }
});

/* ── Formularz zgłoszeniowy: rozgałęzienie "nowa" / "trwająca" polisa + kalendarz kontaktu ──
   Współdzielone przez lp-v1 i lp-v2 (ten sam formularz CF7), selektory po ID/name, więc
   działa identycznie na obu stronach bez dodatkowej konfiguracji. */
document.addEventListener('DOMContentLoaded', () => {
    const branchRadios          = document.querySelectorAll('input[name="typ_polisy"]');
    const dalszaCzesc           = document.getElementById('dalsza_czesc');
    const krokZalaczPolise      = document.getElementById('krok_zalacz_polise');
    const poleDataWystawienia   = document.getElementById('pole_data_wystawienia');
    const policyIssueDateInput  = document.getElementById('data_wystawienia_polisy');
    const policyIssueDateError  = document.getElementById('data_wystawienia_error');
    const poleDataZakonczenia   = document.getElementById('pole_data_zakonczenia');
    const policyEndInput        = document.getElementById('data_zakonczenia_polisy');

    // CF7 nie pozwala ustawić osobnej wartości pola [radio] różnej od wyświetlanej etykiety
    // (mechanizm "pipe" z "etykieta|wartość" wpływa tylko na eksport do maila, nie na atrybut
    // value inputa) — dlatego tag ma krótkie wartości "nowa"/"trwajaca", a pełny tytuł + opis
    // podmieniamy tutaj po stronie JS.
    const branchLabels = {
        nowa: {
            title: 'Mam polisę do opłacenia',
            desc: 'Mam już wystawioną polisę OC/AC z płatnością jednorazową, jeszcze jej nie opłaciłem, ale chciałbym ją opłacić w 2, 4, 11 lub 12 ratach. Chcę poznać ofertę SecurePay.',
        },
        trwajaca: {
            title: 'Nie mam polisy do opłacenia',
            desc: 'Dopiero szukam ubezpieczenia albo moja obecna polisa OC/AC jest już opłacona. Chcę poznać ofertę SecurePay na przyszłość.',
        },
    };
    branchRadios.forEach(radio => {
        const labelSpan = radio.closest('label')?.querySelector('.wpcf7-list-item-label');
        const info = branchLabels[radio.value];
        if (labelSpan && info) {
            labelSpan.innerHTML = '';
            const title = document.createElement('span');
            title.className = 'typ-polisy-title';
            title.textContent = info.title;
            const desc = document.createElement('span');
            desc.className = 'typ-polisy-desc';
            desc.textContent = info.desc;
            labelSpan.append(title, desc);
        }
    });

    // Formularz-level komunikat CF7 (sukces/błąd) domyślnie ląduje na samym końcu <form>
    // (za blokiem RRSO) — przenosimy go raz, żeby wizualnie pojawiał się od razu pod
    // przyciskiem "Wyślij". Sam element nie jest nigdy odtwarzany przez CF7, tylko
    // aktualizowany w miejscu, więc jednorazowe przeniesienie wystarcza na cały czas życia strony.
    const krokSubmit  = document.getElementById('krok_submit');
    const respOutput  = document.querySelector('.wpcf7-response-output');
    if (krokSubmit && respOutput) {
        krokSubmit.insertAdjacentElement('afterend', respOutput);
    }

    // --- Rozgałęzienie "nowa" / "trwająca" ---
    // Przed wyborem widoczne są tylko 2 radio buttony. Po wyborze pokazuje się cała reszta
    // formularza (dalsza_czesc) — a w jej obrębie "Załącz polisę" tylko dla gałęzi "nowa"
    // i "data zakończenia polisy" tylko dla gałęzi "trwająca".
    if (branchRadios.length && dalszaCzesc) {
        branchRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                if (!radio.checked) return;

                dalszaCzesc.classList.remove('hidden');

                const isNowa = radio.value === 'nowa';

                // "Załącz polisę" tylko dla gałęzi "Mam polisę do opłacenia" (nowa)
                if (krokZalaczPolise) krokZalaczPolise.classList.toggle('hidden', !isNowa);
                // "Data wystawienia" tylko dla "Mam polisę" (nowa); "data zakończenia" tylko dla "Nie mam polisy" (trwajaca)
                if (poleDataWystawienia) poleDataWystawienia.classList.toggle('hidden', !isNowa);
                if (poleDataZakonczenia) poleDataZakonczenia.classList.toggle('hidden', isNowa);

                // GTM: mierzymy, która opcja rozgałęzienia jest wybierana. Bez pozycji — wartość
                // (stabilny identyfikator pola CF7, niezależny od treści widocznej etykiety) wystarcza.
                if (typeof window.sendGTMEvent === 'function') {
                    window.sendGTMEvent('form_field_interaction', {
                        interactedFormFieldName: 'typ_polisy',
                        interactedFormFieldValue: radio.value,
                    });
                }
            });
        });
    }

    // --- Kalendarz: data zakończenia obecnej polisy (gałąź "trwająca" = "Nie mam polisy") ---
    if (policyEndInput) {
        flatpickr(policyEndInput, {
            locale: Polish,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd.m.Y',
            minDate: 'today',
        });
    }

    // --- Kalendarz: data wystawienia polisy (gałąź "nowa" = "Mam polisę do opłacenia") ---
    // Dopuszczamy tylko daty w zakresie: dziś − 14 dni do dziś + 30 dni. Wybór daty spoza
    // zakresu pokazuje komunikat błędu i blokuje submit (flatpickr ogranicza picker, ale
    // blokada submit chroni też przed ręczną edycją readonly — defensywnie).
    if (policyIssueDateInput) {
        const MS_PER_DAY = 86400000;

        function issueDateMin() { return new Date(Date.now() - 14 * MS_PER_DAY); }
        function issueDateMax() { return new Date(Date.now() + 30 * MS_PER_DAY); }

        function fmtPL(d) {
            return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' });
        }

        function validateIssueDate(selectedDates) {
            if (!policyIssueDateError) return true;
            if (!selectedDates.length) {
                policyIssueDateError.textContent = '';
                policyIssueDateError.classList.add('hidden');
                return true;
            }
            const min = issueDateMin();
            const max = issueDateMax();
            // Porównujemy po dacie (bez czasu)
            const sel = new Date(selectedDates[0]); sel.setHours(0,0,0,0);
            min.setHours(0,0,0,0); max.setHours(0,0,0,0);
            if (sel < min || sel > max) {
                policyIssueDateError.textContent =
                    `Niestety dla tej daty nie możemy sfinansować polisy. Z SecurePay możesz sfinansować polisy wystawione nie wcześniej niż 14 dni temu lub takie, które zostaną wystawione w ciągu najbliższych 30 dni. Nie masz jeszcze polisy? Wypełnij formularz „Nie mam polisy do opłacenia".`;
                policyIssueDateError.classList.remove('hidden');
                return false;
            }
            policyIssueDateError.textContent = '';
            policyIssueDateError.classList.add('hidden');
            return true;
        }

        const HINT_TEXT = `Z SecurePay możesz sfinansować polisy wystawione nie wcześniej niż 14 dni temu lub takie, które zostaną wystawione w ciągu najbliższych 30 dni. Nie masz jeszcze polisy? Wypełnij formularz „Nie mam polisy do opłacenia".`;

        const issueFp = flatpickr(policyIssueDateInput, {
            locale: Polish,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd.m.Y',
            disableMobile: true,
            minDate: issueDateMin(),
            maxDate: issueDateMax(),
            onChange(selectedDates) {
                validateIssueDate(selectedDates);
            },
            onReady(selectedDates, dateStr, fp) {
                const header = document.createElement('div');
                header.className = 'sp-calendar-header';
                header.innerHTML =
                    `<p>Z SecurePay możesz sfinansować polisy wystawione nie wcześniej niż 14 dni temu lub takie, które zostaną wystawione w ciągu najbliższych 30 dni.</p>` +
                    `<p>Nie masz jeszcze polisy? Wypełnij formularz „Nie mam polisy do opłacenia".</p>`;
                fp.innerContainer.before(header);
            },
        });

        // Blokada submit gdy data wystawienia jest poza zakresem (gałąź "nowa" = "Mam polisę")
        const wpcf7Form = policyIssueDateInput.closest('form');
        if (wpcf7Form) {
            wpcf7Form.addEventListener('submit', (e) => {
                const isTrwajaca = [...document.querySelectorAll('input[name="typ_polisy"]')]
                    .some(r => r.checked && r.value === 'nowa');
                if (!isTrwajaca) return;
                const fp = policyIssueDateInput._flatpickr;
                const dates = fp ? fp.selectedDates : [];
                if (!validateIssueDate(dates) || dates.length === 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    policyIssueDateInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, true);
        }
    }
});

/* ── Video modal (shared by LP v1 and LP v2) ── */
window.securepayInitVideoModal = function securepayInitVideoModal( opts ) {
    const { videoUrl, triggerId, modalId, frameId, closeId, iframeClass, openClass } = opts;
    const trigger  = document.getElementById( triggerId );
    const modal    = document.getElementById( modalId );
    const frame    = document.getElementById( frameId );
    const closeBtn = document.getElementById( closeId );
    if ( !trigger || !modal || !frame || !closeBtn ) return;

    function openModal() {
        frame.innerHTML = '<iframe src="' + videoUrl + '"' +
            ( iframeClass ? ' class="' + iframeClass + '"' : '' ) +
            ' allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        if ( openClass ) {
            modal.classList.remove( 'hidden' );
            modal.classList.add( openClass );
        } else {
            modal.hidden = false;
        }
    }

    function closeModal() {
        if ( openClass ) {
            modal.classList.add( 'hidden' );
            modal.classList.remove( openClass );
        } else {
            modal.hidden = true;
        }
        frame.innerHTML = '';
    }

    trigger.addEventListener( 'click', openModal );
    trigger.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); openModal(); }
    } );
    closeBtn.addEventListener( 'click', closeModal );
    modal.addEventListener( 'click', ( e ) => { if ( e.target === modal ) closeModal(); } );
    document.addEventListener( 'keydown', ( e ) => { if ( e.key === 'Escape' ) closeModal(); } );
};

document.addEventListener( 'wpcf7mailsent', function( event ) {
    // Pobieramy nasze kontenery z DOM
    const formWrapper = document.getElementById('securepay_form_wrapper');
    const successMessage = document.getElementById('securepay_success_message');

    if (formWrapper && successMessage) {
        // 1. Ukrywamy całkowicie formularz
        formWrapper.classList.add('hidden');
        
        // 2. Pokazujemy piękny ekran sukcesu
        successMessage.classList.remove('hidden');

        // 3. (Opcjonalnie, ale to świetny UX) Płynnie przewijamy stronę do komunikatu,
        // na wypadek gdyby formularz był długi i użytkownik był na samym dole.
        successMessage.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
        });
    }
}, false );

/* ── Menu mobilne (hamburger ↔ ×) ── */
document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.getElementById('mobile-menu-toggle');
    const menu   = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;

    const iconOpen  = toggle.querySelector('[data-icon="open"]');
    const iconClose = toggle.querySelector('[data-icon="close"]');

    function setOpen(open) {
        menu.classList.toggle('hidden', !open);
        toggle.setAttribute('aria-expanded', String(open));
        if (iconOpen)  iconOpen.classList.toggle('hidden', open);
        if (iconClose) iconClose.classList.toggle('hidden', !open);
    }

    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
    window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
});

/* ── FAQ: rozwinięcie pytania zamyka pozostałe otwarte ── */
document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('#faq details');
    items.forEach((item) => {
        item.addEventListener('toggle', () => {
            if (!item.open) return;
            items.forEach((other) => { if (other !== item) other.open = false; });
        });
    });
});
